export const CANAL_OFFER = 'canal_offer';
export const ADDON = 'addon';



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/const.js